import { useEffect, useState } from "react"

import { secondsSince } from "@/lib/duration"

/** Seconds elapsed since a stamp, re-read every second while the stamp is set. */
export function useTickingSeconds(iso: string | null | undefined) {
  const [now, setNow] = useState(() => Date.now())
  useEffect(() => {
    if (!iso) return undefined
    const id = window.setInterval(() => setNow(Date.now()), 1000)
    return () => window.clearInterval(id)
  }, [iso])
  return secondsSince(iso, now)
}
